import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { configureBaseMapResourceHints } from './baseMapConfig.js'

configureBaseMapResourceHints()
createRoot(document.getElementById('root')).render(<App />)
